import {
    he,
    picture_convert,
    reels_lenghts,
    reels_pos,
    server_config,
    behavior_config,
    wi
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite,
    madnes_add_to_group,
    madnes_remove_sprite,
    madnes_set_img_center,
    madnes_set_pos,
    madnes_set_scale,
    madnes_set_texture,
    madnes_set_visible,
    madnes_sprite_set_frame
} from "../framework/src/engine/madnes/madnes_object";
import {stopposin, stopposin_old} from "./rof_core";
import {cylinder_pos, icons} from "./rof_config";
import {madnes_add_bitmap_text, madnes_add_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_anim_add} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_fill_range, madnes_set_win_factors} from "../framework/src/engine/madnes/madnes";
import {
    madnes_add_graphics, madnes_add_mask,
    madnes_graphics_begin_fill,
    madnes_graphics_draw_rectangle
} from "../framework/src/engine/madnes/madnes_draw";
import {madnes_audio_allow_multiple} from "../framework/src/engine/madnes/madnes_audio";

// Vytvoreni potrebnych onjektu z nactenych textur.
export function rof_print_desk()
{
    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    /*if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }*/

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    madnes_set_win_factors(
        behavior_config.reel.minBigWinFactor,
        behavior_config.reel.minMegaWinFactor,
        behavior_config.reel.minSuperMegaWinFactor
    );

//	if(
// 		typeof server_config.logic != "undefined" &&
// 		typeof server_config.logic.bet_set != "undefined"
// 	)
// 	{
// 		//madnes_init_bets(server_config.logic.bet_set);
// 	}

    // bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

    madnes_add_img("background", "background", 0, 0);

    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
    for(var i = 0; i < cylinder_pos.length; i++)
    {

        for(var j in server_config.logic.reels[i])
        {
            madnes_add_sprite("reels_bufer_"+i+"_"+j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999);
            madnes_sprite_set_frame("reels_bufer_"+i+"_"+j, 1);

            reels_lenghts[i] = j * 1 + 1;
            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        madnes_add_sprite("reels_bufer_"+i+"_S0", picture_convert[server_config.matrix.reelMatrix[i][2]] + "", cylinder_pos[i], -9999);
        madnes_sprite_set_frame("reels_bufer_"+i+"_S0", 0);

        madnes_add_sprite("reels_bufer_"+i+"_S1", picture_convert[server_config.matrix.reelMatrix[i][1]] + "", cylinder_pos[i], -9999);
        madnes_sprite_set_frame("reels_bufer_"+i+"_S1", 0);

        madnes_add_sprite("reels_bufer_"+i+"_S2", picture_convert[server_config.matrix.reelMatrix[i][0]] + "", cylinder_pos[i], -9999);
        madnes_sprite_set_frame("reels_bufer_"+i+"_S2", 0);

        madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[0] + "_blur", cylinder_pos[i], -9999);
        madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[0] + "_blur", cylinder_pos[i], -9999);

        reels_pos[i] = 0;
    }

    for(var icon in icons) {
        madnes_add_sprite(icon, icon, -9999, -9999);
    }

    setTimeout(function() {
        for(var icon in icons) {
            madnes_remove_sprite(icon);
        }
    }, 100);

    madnes_add_img("bckground2", "reels_cover", 0, 0);

    madnes_add_sprite('left_bet_indicator', 'lines_full', 91, 122);
    madnes_set_img_center('left_bet_indicator', 1, 0);
    madnes_set_scale('left_bet_indicator', 1, 1);

    madnes_add_sprite('right_bet_indicator', 'lines_full', 1189, 122);
    madnes_set_scale('right_bet_indicator', 0, 1);


    madnes_add_img("line_purple", "line_purple", 90, 150);
    madnes_set_visible('line_purple', false);

    madnes_add_img("line_green", "line_green", 90, 547);
    madnes_set_visible('line_green', false);

    madnes_add_img("line_blue", "line_blue", 90, 378);
    madnes_set_visible('line_blue', false);

    madnes_add_img("line_red", "line_red", 90, 212);
    madnes_set_visible('line_red', false);

    madnes_add_img("line_yellow", "line_yellow", 90, 144);
    madnes_set_visible('line_yellow', false);

    for(var rx = 0; rx < 5; rx++) {
        for(var ry = 0; ry < 3; ry++) {
            var wfname = 'winframe_x' + rx + '_y' + ry;
            madnes_add_sprite(wfname, 'winframe_yellow', -9999, -9999);
        }
    }

    for(var rx = 0; rx < 5; rx++) {
        for(var ry = 0; ry < 3; ry++) {
            var symbolCopy = 'symcop_x' + rx + '_y' + ry;
            madnes_add_sprite(symbolCopy, picture_convert[0], -9999, -9999);
        }
    }

    for(var rx = 0; rx < 5; rx++) {
        for(var ry = 0; ry < 3; ry++) {
            var symbolFadein = 'symcop_fadein_x' + rx + '_y' + ry;
            madnes_add_sprite(symbolFadein, picture_convert[0], -9999, -9999);
        }
    }

    var bonusGamesStyle = {
        'font': "24px Arial",
        'stroke': '#000',
        'strokeThickness': 3,
        'fill': "yellow",
    };

    madnes_add_text("text_bonus_games_num", 280, 48, "0/0", bonusGamesStyle);
    madnes_add_text("text_bonus_games", 60, 48, "BONUS GAMES", bonusGamesStyle);

    madnes_set_visible('text_bonus_games', false);
    madnes_set_visible('text_bonus_games_num', false);

    madnes_add_sprite('iconWin', 'icon_Win', 1000, 50);
    madnes_set_img_center('iconWin', 0.5, 0.5);
    madnes_anim_add('iconWin', 'anim', madnes_fill_range(0, 59));
    madnes_set_visible('iconWin', false);

    madnes_add_group("bigwin_bg_group");
    madnes_set_pos("bigwin_bg_group", wi / 2, he / 2);

    madnes_add_group("bigwin_frame_group");
    madnes_set_pos("bigwin_frame_group", wi / 2, he / 2);

    madnes_add_img("bigwin_bg", "bigwin_bg", 0, 0, 1, 0.5, 0.5);
    madnes_add_img("bigwin_shine", "bigwin_shine", -500, 0, 1, 0.5, 0.5);
    madnes_add_img("bigwin_flames_1", "bigwin_flames_1", 0, 122, 1, 0.5, 0.5);
    madnes_add_img("bigwin_flames_2", "bigwin_flames_2", 0, 122, 1, 0.5, 0.5);

    madnes_add_img("bigwin_frame", "bigwin_frame", 0, 0, 1, 0.5, 0.5);
    madnes_add_img("bigwin_frame_shine", "bigwin_frame_shine", 0, 0, 1, 0.5, 0.5);

    madnes_add_img('text_wintype', 'text_bigwin', 0, -126, 1, 0.5, 0.5);
    madnes_add_bitmap_text('windesk_sum', 'bigwin_fonts', 0, 0 - 20, "123", 80);
    madnes_set_img_center("windesk_sum", 0.5, 0.5);

    madnes_set_scale("bigwin_flames_1", 1.1, 1.1);
    madnes_set_scale("bigwin_flames_2", 1.1, 1.1);

    madnes_add_to_group("bigwin_bg_group", "bigwin_bg");
    madnes_add_to_group("bigwin_bg_group", "bigwin_shine");
    madnes_add_to_group("bigwin_bg_group", "bigwin_flames_2");
    madnes_add_to_group("bigwin_bg_group", "bigwin_flames_1");
    madnes_add_to_group("bigwin_bg_group", "text_wintype");


    madnes_add_to_group("bigwin_frame_group", "bigwin_frame");
    madnes_add_to_group("bigwin_frame_group", "bigwin_frame_shine");
    madnes_add_to_group("bigwin_frame_group", "windesk_sum");

    madnes_add_graphics("bigwin_shine_mask", wi / 2 - 706 / 2, he / 2 - 378 / 2);

    madnes_graphics_begin_fill("bigwin_shine_mask", 0xffffff);
    madnes_graphics_draw_rectangle("bigwin_shine_mask", 0, 0, 706, 378);

    madnes_set_visible("bigwin_bg_group", false);
    madnes_set_visible("bigwin_frame_group", false);

    madnes_add_mask("bigwin_bg_group", "bigwin_shine_mask");

    // madnes_recount_bet();

    madnes_audio_allow_multiple("REEL_STOP");
}

var bigwin_anim_num = 1;